import { FunctionComponent as F, useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import PageHeadline from '../../components/UI/Text/PageHeadline';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import RefsTable from '../../components/Refs/RefsTable';
import { getSubtopics, getTopic } from '../../core/http/ref';
import { ITopic } from "@protoplan/types";
import loadingGif from '../../images/loading.gif';
import { ADD_REF, MM_INDEX, PROTOCOL, TOPIC } from '../../core/router/paths';
import AddRef from '../../components/Topic/AddRef';



interface ILocationState
{
  topic?: ITopic
}

interface IParams
{
  topicId?: string
}

const Topic: F = () =>
{
  const navigate = useNavigate();
  const state = useLocation().state as ILocationState | undefined;
  const params: IParams = useParams();
  const topicId = Number(params.topicId);
  const [topic, setTopic] = useState(state?.topic);

  const [subtopics, setSubtopics] = useState<undefined | ITopic[]>(undefined);

  useEffect(() =>
  {
    if(!topicId)
      return;

    if(topicId !== Number(topic?.topicId))
    {
      getTopic(topicId)
        .then(t => setTopic(t || undefined));
    }

    getSubtopics(topicId)
      .then(data => setSubtopics(data || []));
  }, [topicId, state]);

  if(!topicId)
  {
    navigate(PROTOCOL);
    return <></>;
  }

  return (
    <Container>
      <Stack
        justifyContent='center'
        alignItems='center'
        spacing={2}>

        <PageHeadline>{topic?.name || ""}</PageHeadline>

        <Stack justifyContent='left'>
          {subtopics ?
            subtopics.map(t => (
              <Link
                key={t.topicId}
                variant='body2'
                underline='none'
                style={{ cursor: 'pointer', color: 'gray' }}
                onClick={() => navigate("../" + t.topicId, { relative: 'path', state: { topic: t } })}>
                {t.name}
              </Link>)) :
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <img src={loadingGif} width='100px'/>
            </Box>}
        </Stack>

        <RefsTable topicId={topicId} />

      </Stack>
    </Container>);
};

export default Topic;
